// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill';
import 'url-polyfill';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import VueCookie from 'vue-cookie';
import Meta from 'vue-meta';
import * as Sentry from '@sentry/vue';

import 'es6-promise/auto';
import 'animate.css';

import pluginAPI from './plugins/api';

import App from './App';
import router from './router';
import store from './store';
import enUs from './locale/en-US.json';
import thTh from './locale/th-TH.json';
import deDe from './locale/de-DE.json';
import esEs from './locale/es-419.json';
import frFr from './locale/fr-FR.json';
import itIt from './locale/it-IT.json';
import nlNL from './locale/nl-NL.json';
import plPl from './locale/pl-PL.json';
import ptBr from './locale/pt-BR.json';
import trTr from './locale/tr-TR.json';
import zhTw from './locale/zh-TW.json';
import ruRu from './locale/ru-RU.json';

import { locale } from './config/config-cdn';

Vue.use(VueI18n);
Vue.use(VueCookie);
Vue.use(Meta);
Vue.use(pluginAPI);

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV !== 'dev') {
	Sentry.init({
		Vue,
		dsn: 'https://320ea888e8524d8db8855ebc36bf89e8@o878075.ingest.sentry.io/5922874',
		release: process.env.VUE_APP_VERSION,
		environment: process.env.VUE_APP_ENV,
	});
}

const Locale = 'en',
	i18n = new VueI18n({
		Locale,
		silentTranslationWarn: true,
		fallbackLocale: 'en',
		messages: {
			de: deDe,
			en: enUs,
			es: esEs,
			fr: frFr,
			it: itIt,
			nl: nlNL,
			pl: plPl,
			pt: ptBr,
			th: thTh,
			tr: trTr,
			zh: zhTw,
			ru: ruRu,
		},
	});

Vue.mixin({
	props: {
		locale: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			cdnHost: `//${process.env.VUE_APP_CDN_HOST}`,
			staticHost: `${process.env.BASE_URL}static/`,
		};
	},
	created() {
		if (this.locale) {
			this.$i18n.locale = this.locale;
			this.localeCode = locale[this.locale];
		}
	},
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	router,
	store,
	components: { App },
	render: (h) => h(App),
});
